<template>
  <el-row :gutter="10" class="product-box">
    <template v-if="type === 'mandatory'">
      <el-col :sm="colSize" v-for="product in products" :key="product['product-code']">
        <div class="mandatory-border" :class="{ 'no-border': noBorder }">
          <product-info :type="type" :hideTitle="hideTitle" :hideDescription="hideDescription" :item="product" />
        </div>
      </el-col>
    </template>
    <template v-else-if="type === 'one'">
      <el-col :sm="colSize" v-for="product in products" :key="product['product-code']">
        <el-radio v-model="selectedProducts" :label="product['product-code']" border @change="onChange">
          <product-info :type="type" :hideTitle="hideTitle" :hideDescription="hideDescription" :item="product" />
        </el-radio>
      </el-col>
    </template>
    <template v-else>
      <el-checkbox-group v-model="selectedProducts" @change="onChange">
        <el-col :sm="colSize" v-for="product in products" :key="product['product-code']">
          <el-checkbox :label="product['product-code']" :border="!noBorder" :class="{ 'no-border': noBorder }">
            <product-info :type="type" :hideTitle="hideTitle" :hideDescription="hideDescription" :item="product" />
          </el-checkbox>
        </el-col>
      </el-checkbox-group>
    </template>
  </el-row>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ProductInfo from './Info.vue';

export default {
  components: { ProductInfo },
  props: {
    type: { type: String },
    display: { type: String },
    hideTitle: { type: Boolean, default: false },
    hideDescription: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    products: { type: Array },
    selected: { type: String }
  },
  data() {
    return {
      selectedProducts: [],
      colSize: 12,
    }
  },
  computed: {
    ...mapGetters('renewal', ['membershipForm'])
  },
  mounted() {
    this.colSize = this.display === 'grid' ? 12 : 24;

    if (this.type === 'mandatory') {
      this.selectedProducts = this.products.map(ap => ap['product-code']);
      this.onChange();
    } else if (this.selected) {
      this.selectedProducts = this.type === 'one' ? this.selected : [this.selected];
    } else if (this.type === 'one') {
      this.selectedProducts = null;
    }
  },
  methods: {
    ...mapMutations('renewal', ['setPayload']),

    onChange() {
      this.$emit('save-selection', this.selectedProducts);
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/fonts/stylesheet.css';

.product-box {
  .el-radio {
    width: 100%;
    height: auto;
    display: flex;
    padding: 15px;

    >>>.el-radio__inner {
      width: 18px;
      height: 18px;

      &::after {
        width: 6px;
        height: 6px;
      }
    }

    >>>.el-radio__label {
      flex-grow: 1;
    }
  }

  .el-checkbox {
    width: 100%;
    height: auto;
    display: flex;
    padding: 15px;

    &.no-border {
      padding-left : 0;
      padding-right: 0;
    }

    >>>.el-checkbox__inner {
      width: 18px;
      height: 18px;

      &::after {
        width: 5px;
        height: 10px;
        left: 5px;
        top:0px;
      }
    }

    >>>.el-checkbox__label {
      flex-grow: 1;
    }
  }

  .mandatory-border {
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: normal;
    padding: 15px;

    &.no-border {
      border: none;
      padding-left : 0;
      padding-right: 0;
    }
  }
}
</style>
